import React from "react";
import { useDispatch, useSelector } from "react-redux";
import useValidateCard from "./hooks/useValidateCard";
import texts from "../../texts/texts";
import axios from "axios";

export function Recharge() {
    const dispatch = useDispatch();
    const card = useSelector((state) => state.card);
    const amount = useSelector((state) => state.rechargeAmount);
    const policy = useSelector((state) => state.rechargePolicy);
    const confirm = useSelector((state) => state.rechargeConfirm);
    const errors = useSelector((state) => state.errors);
    const pending = useSelector((state) => state.pending);
    const isCardValid = useValidateCard();

    // const processAmountValue = (e) => {
    //     e.preventDefault();

    //     const cursor = e.target.selectionStart;

    //     dispatch({ type: "UPDATE_AMOUNT", amount: e.target.value });

    //     window.requestAnimationFrame(() => {
    //         e.target.selectionStart = cursor;
    //         e.target.selectionEnd = cursor;
    //     });
    // };

    const proceedRecharge = async () => {
        dispatch({ type: "DELETE_ERROR", error: "amount" });
        dispatch({ type: "DELETE_ERROR", error: "recharge" });

        if (!isCardValid(card)) {
            return;
        }

        const minAmount = 10;
        const maxAmount = 200;
        const amountNumber = parseFloat(amount);

        if (isNaN(amountNumber)) {
            if (amount === "") {
                dispatch({
                    type: "ADD_ERROR",
                    error: "amount",
                    message: "",
                });
                return;
            } else {
                dispatch({
                    type: "ADD_ERROR",
                    error: "amount",
                    message: texts.errors.wrongAmountFormat,
                });
                return;
            }
        }

        if (amountNumber < minAmount) {
            dispatch({
                type: "ADD_ERROR",
                error: "amount",
                message: `Der Mindestbetrag für die Aufladung beträgt ${minAmount} €`,
            });
            return;
        } else if (amountNumber > maxAmount) {
            dispatch({
                type: "ADD_ERROR",
                error: "amount",
                message: `Der Höchstbetrag für die Aufladung beträgt ${maxAmount} €`,
            });

            return;
        }

        dispatch({ type: "UPDATE_PENDING", pending: "recharge" });

        try {
            const hash = await axios
                .post(`/api/create-ipg-hash`, {
                    card: card,
                    amount: amount,
                })
                .then(function (response) {
                    console.log(response);
                    document.getElementById("txndatetime").value =
                        response.data.time;
                    document.getElementById("hash").value = response.data.hash;
                    document.getElementById("oid").value = response.data.oid;
                    document.getElementById("responseFailURL").value =
                        window.APP_URL + "/endpoint-fail/" + response.data.oid;
                    document.getElementById("responseSuccessURL").value =
                        window.APP_URL +
                        "/endpoint-success/" +
                        response.data.oid;
                    document.getElementById("amount").value = parseFloat(
                        amount.replace(",", ".")
                    ).toFixed(2);

                    return response.data;
                });

            const result = await axios.post(`/api/transactions/create`, {
                oid: hash.oid,
                card: card,
                amount: amount,
            });
            console.log(result);

            document.forms["recharge"].submit();
        } catch (error) {
            console.log(error);
            if (error.response.status == 404) {
                dispatch({
                    type: "ADD_ERROR",
                    error: "card",
                    message: texts.errors.wrongNumber,
                });
            } else if (error.response.status == 403) {
                dispatch({
                    type: "ADD_ERROR",
                    error: "recharge",
                    message: texts.errors.notAllowed,
                });
            } else {
                dispatch({
                    type: "ADD_ERROR",
                    error: "recharge",
                    message:
                        error.response.data?.error || texts.errors.unknownError,
                });
            }
        }

        dispatch({ type: "UPDATE_PENDING", pending: "" });
    };

    return (
        <div className="stack stack_large">
            <div className="recharge stack stack_big">
                <form
                    id="recharge"
                    method="post"
                    action={window.IPG_URL}
                    style={{ display: "none" }}
                >
                    <input
                        type="hidden"
                        name="chargetotal"
                        id="amount"
                        value=""
                    />
                    <input type="hidden" name="currency" value="978" />
                    <input
                        type="hidden"
                        name="responseFailURL"
                        id="responseFailURL"
                        value=""
                    />
                    <input
                        type="hidden"
                        name="responseSuccessURL"
                        id="responseSuccessURL"
                        value=""
                    />
                    <input
                        type="hidden"
                        name="storename"
                        value={window.STORE_ID}
                    />
                    <input
                        type="hidden"
                        name="timezone"
                        value="Europe/Berlin"
                    />
                    <input
                        type="hidden"
                        name="txndatetime"
                        id="txndatetime"
                        value=""
                    />
                    <input type="hidden" name="mode" value="payonly" />
                    <input type="hidden" name="oid" id="oid" value="" />
                    <input
                        type="hidden"
                        name="checkoutoption"
                        value="combinedpage"
                    />
                    <input type="hidden" name="txntype" value="sale" />
                    <input
                        type="hidden"
                        name="hash_algorithm"
                        value="HMACSHA256"
                    />
                    <input type="hidden" name="customParam_card" value={card} />
                    <input
                        type="hidden"
                        name="hashExtended"
                        id="hash"
                        value=""
                    />
                </form>
                <div className="stack stack_tiny">
                    <div className="recharge__amount">
                        <label htmlFor="amount">
                            Ich möchte folgenden Geldbetrag aufladen:
                        </label>
                        {/* <div>
                            <input
                                type="text"
                                className={`field ${
                                    errors.amount ? "field_error" : ""
                                }`}
                                value={amount}
                                onChange={(e) => {
                                    processAmountValue(e);
                                    dispatch({
                                        type: "DELETE_ERROR",
                                        error: "amount",
                                    });
                                }}
                                inputMode="numeric"
                            ></input>
                            <div className="recharge__currency">€</div>
                        </div> */}
                        <div>
                            <select
                                name="amount"
                                id="amount"
                                className="field"
                                onChange={(e) => {
                                    dispatch({
                                        type: "UPDATE_AMOUNT",
                                        amount: e.target.value,
                                    });
                                }}
                            >
                                <option value="15">15€</option>
                                <option value="25">25€</option>
                                <option value="50">50€</option>
                                <option value="75">75€</option>
                                <option value="100">100€</option>
                            </select>
                        </div>
                    </div>
                    {(errors.recharge?.message || errors.amount?.message) && (
                        <div className="status status_error status_right">
                            {errors.recharge?.message || ""}
                            {errors.amount?.message || ""}
                        </div>
                    )}
                </div>
                <div className="stack stack_small">
                    <label className="recharge__check small">
                        <input
                            type="checkbox"
                            name="check"
                            checked={policy}
                            onChange={(e) => {
                                dispatch({
                                    type: "UPDATE_POLICY",
                                    policy: e.target.checked,
                                });
                            }}
                        ></input>
                        Ich bestätige die Anerkennung der
                        <a
                            href="https://www.mainzer-mobilitaet.de/tickets-und-tarife/bezahlkarte/agb"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Allgemeinen Geschäftsbedingungen (AGB)
                        </a>
                    </label>
                    <label className="recharge__check small">
                        <input
                            type="checkbox"
                            name="check"
                            checked={confirm}
                            onChange={(e) => {
                                dispatch({
                                    type: "UPDATE_CONFIRM",
                                    confirm: e.target.checked,
                                });
                            }}
                        ></input>
                        Ich bestätige, dass es sich bei der Kartennummer <strong>{card}{" "}</strong>
                        um die korrekte Kartennummer handelt, welche aufgeladen
                        werden soll.
                    </label>
                </div>
            </div>
            <div className="stack stack_small">
                <button
                    className="button button_weinrot"
                    onClick={() => proceedRecharge()}
                    disabled={!policy || !confirm || pending == "recharge"}
                >
                    Weiter zum Zahlungsmittel
                </button>
                <button
                    className="button"
                    onClick={() =>
                        dispatch({
                            type: "UPDATE_VIEW",
                            view: "home",
                        })
                    }
                >
                    Zurück zur Übersicht
                </button>
            </div>
        </div>
    );
}
